import { List } from 'immutable';
import SearchViewFilterRecord from 'SalesContentIndexUI/data/records/SearchViewFilterRecord';
import filter from 'SalesContentIndexUI/data/utils/filter';
import * as SearchFields from 'SalesContentIndexUI/data/constants/SearchFields';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
export default (({
  looseItemContentType,
  folderContentType,
  sort
}) => {
  const filterContentTypeByAll = filter(SearchFields.CONTENT_TYPE_FIELD, looseItemContentType, folderContentType);
  const filterByItemsNotInFolders = filter(SearchFields.FOLDER_ID_FIELD);
  const defaultFilters = List([filterContentTypeByAll, filterByItemsNotInFolders]);
  const isSearchingInFolder = filters => {
    const folderFilter = filters.find(({
      field
    }) => field === SearchFields.FOLDER_ID_FIELD);

    // @ts-expect-error values could be an array
    return folderFilter && !folderFilter.values.isEmpty();
  };
  return SearchViewFilterRecord({
    id: DefaultFilterNames.ALL,
    getFilters: () => defaultFilters,
    getSearchQueryOverride: ({
      searchQuery
    }) => {
      const {
        query,
        filters
      } = searchQuery;
      if (query === '' || isSearchingInFolder(filters)) {
        return searchQuery;
      }
      return searchQuery.set('filters', List([filterContentTypeByAll]));
    },
    getSort: () => sort || DefaultSort
  });
});